import { Store, CreateStoreRequest, CreateStoreResponse } from "@functions-types";
import { makeCloudFunction } from "../makeCloudFunction";

export type { Store };
export const createStore = makeCloudFunction<
  CreateStoreRequest,
  CreateStoreResponse
>("store", "createStore");
